import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from "moment-timezone";

Vue.use(Vuex)

const ttl_time_for = 86400000

function setWithExpiry(key, value, ttl) {
    const now = new Date()

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    try {
        const item = JSON.parse(itemStr)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    } catch (exception_var) {
        return null
    }

}

export default new Vuex.Store({
    state: {
        status: '',
        token: getWithExpiry('token') || '',
        user_role: localStorage.getItem('user_role') || '',
        user_id: localStorage.getItem('user_id') || '',
        date_value: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        query_flag: new Date(),
        query_var: '',
        query_cond: '',
        query_value: '',
        // 加载状态管理
        loading: {
            visible: false,
            text: '春播万象大数据平台',
            subText: ''
        },
        shengquName: '',
        dibanName: '',
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token) {
            state.status = 'success'
            state.token = token
            state.user_role = localStorage.getItem('user_role') || ''
            state.user_id = localStorage.getItem('user_id') || ''
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
            state.user_id = ''
            state.user_role = ''
        },
        // 加载状态控制
        setLoading(state, { visible, text, subText }) {
            state.loading.visible = visible
            if (text !== undefined) state.loading.text = text
            if (subText !== undefined) state.loading.subText = subText
        },
        showLoading(state, { text, subText } = {}) {
            state.loading.visible = true
            if (text !== undefined) state.loading.text = text
            if (subText !== undefined) state.loading.subText = subText
        },
        hideLoading(state) {
            state.loading.visible = false
        },
        // 设置省区名称
        setShengquName(state, shengquName) {
            state.shengquName = shengquName
        },
        // 设置地办名称
        setDibanName(state, dibanName) {
            state.dibanName = dibanName
        },
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: process.env.VUE_APP_API_HOST + '/login', data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        const user = resp.data.user
                        const user_id = user.user_id
                        const user_role = user.user_role
                        setWithExpiry('token', token, ttl_time_for)
                        localStorage.setItem('user_id', user_id)
                        localStorage.setItem('user_role', user_role)
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        localStorage.removeItem('user_id')
                        localStorage.removeItem('user_role')
                        reject(err)
                    })
            })
        },
        register({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios({ url: 'http://localhost:3000/register', data: user, method: 'POST' })
                    .then(resp => {
                        const token = resp.data.token
                        const user = resp.data.user
                        const user_id = user.user_id
                        const user_role = user.user_role
                        setWithExpiry('token', token, ttl_time_for)
                        localStorage.setItem('user_id', user_id)
                        localStorage.setItem('user_role', user_role)
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error', err)
                        localStorage.removeItem('token')
                        localStorage.removeItem('user_id')
                        localStorage.removeItem('user_role')
                        reject(err)
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('logout')
                console.log(reject)
                localStorage.removeItem('token')
                localStorage.removeItem('user_id')
                localStorage.removeItem('user_role')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        // 设置省区名称
        setShengquNameAction({ commit }, shengquName) {
            commit('setShengquName', shengquName)
        },
        // 设置地办名称
        setDibanNameAction({ commit }, dibanName) {
            commit('setDibanName', dibanName)
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        user_id: state => state.user_id,
        user_role: state => state.user_role,
        // 加载状态获取器
        loadingVisible: state => state.loading.visible,
        loadingText: state => state.loading.text,
        loadingSubText: state => state.loading.subText,
        // 获取省区名称 
        shengquName: state => state.shengquName,
        // 获取地办名称
        dibanName: state => state.dibanName,
    }
})
